import React, { PureComponent } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { getTranslate } from 'react-localize-redux';
import { Menu } from 'antd';
import { connect } from 'react-redux';
import * as R from 'ramda';
import { matchPath } from 'react-router';

import { getRole } from '../../common/helpers';

@withRouter
@connect(({ localize, session }) => ({
  translate: getTranslate(localize),
  userId: R.path(['user', 'id'], session),
  loggedIn: !!(session && session.authenticated && session.user),
  userName: R.pathOr('', ['user', 'userName'], session)
}))
export default class NavMenu extends PureComponent {
  constructor() {
    super();
    this.state = {
      role: ''
    }
  }
  async componentDidUpdate() {
    const role = await getRole();
    this.setState({ role })
  }

  get navLinkPaths() {
    const { translate } = this.props;
    const { role } = this.state;
    const loggedInLinks = this.props.loggedIn
      ? [
          {
            label: translate('nav.loan'),
            path: '/loan',
            exact: true
          }
        ]
      : [];
      if (['LENDER'].includes(role)) {
        loggedInLinks.push({
          label: translate('nav.approval'),
          path: '/approval',
          exact: true
        });
      }
      // if (['FINANCE'].includes(role)) {
      //   loggedInLinks.push({
      //     label: translate('nav.transaction'),
      //     path: '/transaction',
      //     exact: true
      //   });
      // }
      if (['ADMIN'].includes(role)) {
        loggedInLinks.push(
            {
              label: translate('nav.ovo_admin_tab_title_funding_limit'),
              path: '/funding-limit',
              exact: true
            },
            // {
            //   label: translate('nav.ovo_admin_tab_title_lender_registrations'),
            //   path: '/lender-registrations',
            //   exact: true
            // }
        );
      }
    return [{ label: translate('nav.home'), path: '/', exact: true }, ...loggedInLinks];
  }

  getMenuItems() {
    return this.navLinkPaths.map(({ label, path, exact }, key) => (
      <Menu.Item key={key}>
        <Link to={{ pathname: path }}>{label}</Link>
      </Menu.Item>
    ));
  }

  render() {
    const currentSelectedNavKey = this.navLinkPaths.findIndex(
      ({ path, exact }) => matchPath(this.props.location.pathname, { path, exact })
    );
    const selectedKeys = [
      currentSelectedNavKey >= 0 ? currentSelectedNavKey.toString() : null
    ];
    return (
      <Menu id="nav" mode="horizontal" selectedKeys={selectedKeys} onClick={this.props.handleTabClick}>
        {this.getMenuItems()}
      </Menu>
    );
  }
}
